import { TRootState } from 'store/store';

export const getTracks = (state: TRootState) => state.tracks;
